import { getOrderTypes } from 'shared-js/settings-services/order-types-service'
import _ from 'lodash'

export function cleanStations (settingsBlob) {
  const orderTypes = getOrderTypes(settingsBlob).map(it => it.code)
  settingsBlob.stations.forEach(station => cleanStation(station, settingsBlob, orderTypes))
}

export function cleanStation (station, settingsBlob, orderTypes = null) {
  if (!orderTypes) {
    orderTypes = getOrderTypes(settingsBlob).map(it => it.code)
  }

  if (_.has(station, 'orderTypes')) {
    station.orderTypes.types = station.orderTypes.types.filter(it => orderTypes.includes(it))

    if (!orderTypes.includes(station.orderTypes.default)) {
      station.orderTypes.default = null
    }
  }

  return station
}
